{% block verign_dv_accessibility_sw_purchase_button %}
    <mt-button @click="openPurchaseModal">
        Purchase
    </mt-button>
{% endblock %}